<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Vehicle type management</h1>
    <vehicleTypeManage/>
  </v-card>
</template>

<script>

import vehicleTypeManage from "@/components/back-office/Messenger/Vehicle/VehicleTypeListTable";
export default {
  components: {
    vehicleTypeManage
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Messenger",
        disabled: false,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/messenger/vehicletype"
      },
      {
        text: "Vehicle type Management",
        disabled: true,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/messenger/vehicletype"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
